import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Header from '../common/Header';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!email || !password) {
      setError('Email and password are required');
      return;
    }
    setLoading(true);
    try {
      await login(email.trim(), password);
      const fromView = location.state?.fromView || 'dashboard';
      try { localStorage.setItem('', fromView); } catch(e) {}
      navigate('/', { replace: true });
    } catch (err) {
      setError(err?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const heroBgUrl = `${process.env.PUBLIC_URL}/images/circular_economy_home.png`;

  return (
    <div className="min-h-screenbg-gray-100">
      <Header currentView="login" />
      
      <div className="min-h-[90vh] flex flex-col lg:flex-ro items-center justify-center px-4">
        
        <div className="w-full max-w-md bg-white p-6 my-5 border border-cyan-500 rounded-xl shadow">
          <p className="text-center pt- mt- mb-4 text-red-500">Please sign in to access the Dashboard and Asset Manager</p> 
        </div>

      <div className=" flex flex-col lg:flex-row items-center justify-center p-6 border border-cyan-500 bg-cyan-500 rounded-xl shadow">

        <div className="w-full max-w-md bg-cyan-500 p-6 border-cyan- rounded-xl">
         <img src={heroBgUrl} alt="Circular Economy Home" className="max-w-full max-h-full object-cover" />
        </div>

       <div className="w-full max-w-md bg-white p-6 border border-cyan-500 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-1 text-gray-800">Sign in</h2>
        <p className="text-sm text-gray-600 mb-4">Welcome back. Please sign in to continue.</p>
        {error && <div className="mb-3 p-2 text-sm rounded bg-red-50 text-red-700 border border-red-200">{error}</div>}
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="block text-sm text-gray-700 mb-1">Email</label>
            <input type="email" autoComplete="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="you@example.com" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Password</label>
            <input type="password" autoComplete="current-password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} className={`w-full py-2 rounded text-white font-medium ${loading ? 'bg-gray-400' : 'bg-cyan-600 hover:bg-cyan-700'}`}>{loading ? 'Signing in…' : 'Sign in'}</button>
        </form>
        <div className="mt-4 text-sm flex justify-between">
          <Link to="/forgot-password" className="text-cyan-700 hover:underline">Forgot password?</Link>
          <Link to="/register" className="text-cyan-700 hover:underline">Create account</Link>
        </div>
       </div>

     </div>

     </div>
   </div>
 );
};

export default LoginPage;
